import {Input, Modal, Row, Col} from 'antd';
import {useState} from 'react';

export const EmailEntryModal = ({open, onOk, onClose, props}) => {

    const [email, setEmail] = useState("");
    const [description, setDescription] = useState("");

    const clearInputs = () => {
        setEmail("");
        setDescription("");
    }
    const handleEmOk = () => {
        if (onOk) {
            onOk({email, description});
        }
        clearInputs();
    }

    const handleEmCancel = () => {
        if (onClose) {
            onClose();
        }
        clearInputs();
    }

    const onEmailChange = (e) => {
        setEmail(e.target.value);
    }

    const onDescriptionChange = (e) => {
        setDescription(e.target.value);
    }

    return <Modal open={open} title={"New Email Address"} onOk={handleEmOk} onCancel={handleEmCancel}>
        <>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={24}><Input placeholder={"Email"} onChange={onEmailChange}/></Col>
        </Row>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={24}><Input placeholder={"Description"} onChange={onDescriptionChange}></Input></Col>
        </Row>
        </>
    </Modal>
}